/** Fortify Platform Investor Overview */

import { GENERAL_INQUIRIES_EMAIL } from "lib/fortifyContact";
import {
  WITHDRAWAL_DEADLINE_AFTER_AMENDMENT_PHRASE,
  WITHDRAWAL_DEADLINE_PHRASE,
} from "lib/ni45110Copy";

export const investorEligibilityMeta = {
  company: "FORTIFY PORTAL, INC.",
  title: "Investor Overview",
  lastUpdated: "Last updated: May 21, 2026",
  contactLine: `fortifyportal.ca | ${GENERAL_INQUIRIES_EMAIL}`,
};

export const investorEligibilityIntro =
  'The Platform operates under the start-up crowdfunding exemptions set out in National Instrument 45-110 ("NI 45-110"). To invest on the Platform, you must meet all of the following requirements.';

export const investorEligibilitySections = [
  {
    number: "1",
    title: "Basic Eligibility Requirements",
    listItems: [
      "Be at least 18 years of age",
      "Be a Canadian resident",
      "Have a valid Canadian bank account or approved Canadian payment method",
      "Complete the investor registration form",
    ],
  },
  {
    number: "2",
    title: "Investment Limit",
    paragraphs: [
      "Under NI 45-110, the maximum investment per investor per offering is $2,500, regardless of investor status. This limit applies per offering and applies to every investor on the Platform.",
      "You are responsible for ensuring you do not exceed this limit in any single offering. The Platform enforces this limit automatically and will block any subscription that would cause your total investment in a single offering to exceed $2,500.",
    ],
  },
  {
    number: "3",
    title: "Right of Withdrawal",
    paragraphs: [
      `Under NI 45-110, all investors have the right to withdraw any investment by delivering notice to Fortify Portal, Inc. ${WITHDRAWAL_DEADLINE_PHRASE}. If the offering document is amended, your withdrawal right is re-triggered and you have until ${WITHDRAWAL_DEADLINE_AFTER_AMENDMENT_PHRASE} to withdraw.`,
    ],
  },
  {
    number: "4",
    title: "Important Notice",
    paragraphs: [
      "Fortify Portal, Inc. is not registered as a dealer under applicable Canadian securities legislation and relies on the dealer registration exemption under NI 45-110.",
      "Fortify Portal, Inc. does not provide investment advice and all investment decisions are yours alone.",
      "Investing in early-stage companies is highly speculative. You may lose all of the money you invest.",
    ],
  },
];
